import {SxType} from "@baseTypes/sx/sxTypes";

export const sx:SxType = {
    root:{
        width:'100%'
    },
    divider:{
        width:'100%'
    },
    btn:{
        fontSize:'10px'
    },
    list:{
        width:'100%'
    }
}
